import { useDisclosure } from '@core/ui-elements'
import { useCallback, useState } from 'react'

import BottomSheet, { IBottomSheet } from '../bottom-sheet'

export const useBottomSheetMethods = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [bottomSheets, setBottomSheets] = useState<IBottomSheet[]>([])

  const openBottomSheet = useCallback(
    (props: IBottomSheet) => {
      setBottomSheets((prev) => [...prev, props])
      if (!isOpen) {
        onOpen()
      }
    },
    [isOpen, onOpen]
  )

  const closeBottomSheet = useCallback(
    (index: number = 0) => {
      setBottomSheets((prev: IBottomSheet[]) => {
        if (bottomSheets.length <= 1) {
          onClose()
        }

        return prev.splice(index, -1)
      })
    },
    [bottomSheets, onClose]
  )

  const renderBottomSheets = () =>
    bottomSheets.map((props, index) => (
      <BottomSheet
        key={index}
        defaultIsOpen={isOpen}
        {...props}
        handleOnClose={() => closeBottomSheet(index)}
      />
    ))

  return {
    onClose: closeBottomSheet,
    renderBottomSheets,
    openSuccess: (props: IBottomSheet) =>
      openBottomSheet({ ...props, color: 'green' }),
    openError: (props: IBottomSheet) =>
      openBottomSheet({ ...props, color: 'red' }),
    openInfo: (props: IBottomSheet) =>
      openBottomSheet({ ...props, color: 'default' }),
    openWarning: (props: IBottomSheet) =>
      openBottomSheet({ ...props, color: 'yellow' }),
  }
}
